import { FC } from 'react'

import { useSuspenseQuery } from '@tanstack/react-query'

import { Cluster, Icon, Stack, Typography } from '@forto-dev/phoenix-ui-core'
import { Widget, WidgetFooter, WidgetHeader, WidgetTitle } from '@forto-dev/phoenix-ui-core/ship'

import { useLocalisation } from '@/utils/localisation'

import { getFilteredCustomerRequestedQuotesByFilterType } from '../api/customer-requested-quotes.service'
import { getFilteredQuoteSheetsByFilterType, ManualQuoteListFilterType } from '../api/manual-quotes.service'
import { customerRequestedQuotesQueryOptions } from '../api/useCustomerRequestedQuotes'
import { manualQuotesQueryOptions } from '../api/useManualQuotes'

export const QuotesSidebar: FC = () => {
  const { translate } = useLocalisation()
  const quotes = useSuspenseQuery(manualQuotesQueryOptions())
  const customerRequestedQuotes = useSuspenseQuery(customerRequestedQuotesQueryOptions())

  const pendingManualQuotes = getFilteredQuoteSheetsByFilterType(
    quotes.data ?? [],
    ManualQuoteListFilterType.PENDING
  ).length

  const pendingRequestedQuotes = getFilteredCustomerRequestedQuotesByFilterType(
    customerRequestedQuotes.data ?? [],
    ManualQuoteListFilterType.PENDING
  ).length

  const pending = pendingManualQuotes + pendingRequestedQuotes

  const declinedManualQuotes = getFilteredQuoteSheetsByFilterType(
    quotes.data ?? [],
    ManualQuoteListFilterType.DECLINED
  ).length
  const declinedRequestedQuotes = getFilteredCustomerRequestedQuotesByFilterType(
    customerRequestedQuotes.data ?? [],
    ManualQuoteListFilterType.DECLINED
  ).length

  const declined = declinedManualQuotes + declinedRequestedQuotes

  return (
    <Stack gap={16}>
      {pending > 0 ? (
        <Widget variant="primary">
          <WidgetHeader>
            <WidgetTitle>{translate('quotes.pending')}</WidgetTitle>
          </WidgetHeader>
          <WidgetFooter>
            <Cluster gap={4} y="center">
              <Icon size="md" name="Warning" />
              <Typography variant="h3">{pending}</Typography>
            </Cluster>
          </WidgetFooter>
        </Widget>
      ) : null}
      {declined >= 0 ? (
        <Widget variant="neutral">
          <WidgetHeader>
            <WidgetTitle>{translate('quotes.declined')}</WidgetTitle>
          </WidgetHeader>
          <WidgetFooter>
            <Cluster gap={4} y="center">
              <Icon size="md" name="Warning" />
              <Typography variant="h3">{declined}</Typography>
            </Cluster>
          </WidgetFooter>
        </Widget>
      ) : null}
    </Stack>
  )
}
